
import { MapLocation } from '@/types/location';

export const ledScreens: MapLocation[] = [
  {
    id: 10013,
    name: "Digital Screen – Majmaa",
    type: "Digital Screen",
    devices: 1,
    coordinates: [25.896944, 45.350278], // Converted from 25°53'52.70"N 45°21'0.94"E
    region: "Majmaa",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Majmaa\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/743b12cc-ff8a-4808-ba54-c8a33b311eb3.png"
    }
  },
  {
    id: 10014,
    name: "Digital Screen – Qassim",
    type: "Digital Screen",
    devices: 1,
    coordinates: [26.42233333, 43.91002778], // Converted from 26°25'20.4"N 43°54'36.1"E
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Qassim\nPrice: 1,572 SAR per screen per day",
      screenDimensions: "10.25m x 6m",
      referenceImage: "/images/47dc7cc0-99ec-4336-9b00-3e8020349ea1.png"
    }
  },
  {
    id: 10015,
    name: "Digital Screen – Qassim 2",
    type: "Digital Screen",
    devices: 1,
    coordinates: [26.346721667, 43.978886111], // Converted from 26°20'46.02"N 43°58'40.19"E
    region: "Qassim",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Qassim\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/ad3e9e01-1028-4eb5-9200-84a90c5b73be.png"
    }
  },
  {
    id: 10016,
    name: "Digital Screen – Sakaka",
    type: "Digital Screen",
    devices: 1,
    coordinates: [29.951944, 40.195500], // Converted from 29°57'09.90"N 40°11'43.80"E
    region: "Sakaka",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Sakaka\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/46bdd048-a087-413c-93f4-e219b2ba2f86.png"
    }
  },
  {
    id: 10017,
    name: "Digital Screen – Sakaka 2",
    type: "Digital Screen",
    devices: 1,
    coordinates: [29.888251389, 40.217222222], // Converted from 29°53'17.7"N 40°13'02.0"E
    region: "Sakaka",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Sakaka\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/859c54aa-266a-4759-be24-42bcbf276a48.png"
    }
  },
  {
    id: 10018,
    name: "Digital Screen – Arar",
    type: "Digital Screen",
    devices: 1,
    coordinates: [30.975278, 41.040833], // Converted from 30°58'31.0"N 41°02'25.5"E
    region: "Arar",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Arar\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/5845529b-dac3-4850-bbf4-3c66682a7d59.png"
    }
  },
  {
    id: 10019,
    name: "Digital Screen – Arar 2",
    type: "Digital Screen",
    devices: 1,
    coordinates: [30.969916667, 41.032722222], // Converted from 30°58'11.7"N 41°01'57.8"E
    region: "Arar",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Arar\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/8c2712fd-5fac-40cc-bdbc-ec83599b30f4.png"
    }
  },
  {
    id: 10020,
    name: "Digital Screen – Arar 3",
    type: "Digital Screen",
    devices: 1,
    coordinates: [30.981531694630526, 41.02735919381676],
    region: "Arar",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Arar\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/efa68400-9632-4f30-8538-ed6a35d36356.png"
    }
  },
  {
    id: 10021,
    name: "Digital Screen – Al Qurayyat",
    type: "Digital Screen",
    devices: 1,
    coordinates: [31.312361, 37.342861], // Converted from 31°18'44.5"N 37°20'34.3"E
    region: "Al Qurayyat",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Al Qurayyat\nPrice: 1,215 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/58f79256-4f07-4c6f-9cfe-95ff1be744d9.png"
    }
  },
  {
    id: 10026,
    name: "Digital Screen – Yanbu",
    type: "Digital Screen",
    devices: 1,
    coordinates: [24.144441389, 38.082583056], // Converted from 24°08'39.97"N 38°04'98.31"E
    region: "Yanbu",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Yanbu\nPrice: 1,286 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/3afeebe2-a628-413b-b25f-bf1f2063864a.png"
    }
  },
  {
    id: 10027,
    name: "Digital Screen – Yanbu 2",
    type: "Digital Screen",
    devices: 1,
    coordinates: [24.099383333, 38.034722222], // Converted from 24°05'57.8"N 38°02'05.0"E
    region: "Yanbu",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Yanbu\nPrice: 1,286 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/714626d5-ac50-489c-854b-647ee3a2b24b.png"
    }
  },
  {
    id: 10028,
    name: "Digital Screen – Yanbu 3",
    type: "Digital Screen",
    devices: 1,
    coordinates: [24.135630556, 38.094169444], // Converted from 24°08'10.28"N 38°05'38.11"E
    region: "Yanbu",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Digital Screen location in Yanbu\nPrice: 1,286 SAR per screen per day",
      screenDimensions: "8m x 6m",
      referenceImage: "/images/c8524fdc-2242-4cec-b691-dec74fb9cfe8.png"
    }
  },
  {
    id: 10025,
    name: "Curved Digital Screen – Hafar Al Batin",
    type: "Curved LED Screen",
    devices: 1,
    coordinates: [28.254638889, 45.974722222], // Converted from 28°25'46.7"N 45°58'29.0"E
    region: "Hafar Al Batin",
    mediaOwner: "Attention",
    mediaKind: "Outdoor",
    screenType: "Digital Signage",
    details: {
      description: "Curved Digital Screen location in Hafar Al Batin\nPrice: 1,572 SAR per screen per day",
      screenDimensions: "10.25m x 6m",
      referenceImage: "/images/7030c955-c80a-4b46-bd8a-d1ada00d276b.png"
    }
  }
];
